module.exports = __webpack_public_path__ + "static/media/qunClose.18fd9cea.png";